import { BaseModel } from '@/api/base-model'
import { BrandingAPI } from '@/api/backend-client'

export class Branding extends BaseModel<Branding> {
    protected collectionName = BrandingAPI.collectionName

    constructor(
        public id: string,
        public displayName: string,
        public emailDomain: string,
        public primaryColor: string,
        public logo: string|null,
        public logoPath: string|null,
        public logoUrl: string|null,
        public createdAt: Date,
        public updatedAt: Date,
    ) { super(id) }

    static fromData(data: any): Branding {
        if (data === null || typeof data === 'string' || data instanceof Branding) {
            return data
        }

        return new Branding(
            data.id,
            data.displayName,
            data.emailDomain,
            data.primaryColor,
            data.logo,
            data.logoPath,
            data.logoUrl,
            data.createdAt,
            data.updatedAt,
        )
    }
}
